export default function IntroductionSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            欢迎来到色彩魔法的世界
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            《好色精灵探访记》是一部充满奇幻色彩与创意的互动体验故事。
            在这个世界里，六大精灵族各自守护着一种独特的色彩力量，
            他们用色彩编织出最动人的冒险篇章。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-background-100 rounded-lg p-6 md:p-8 text-center group hover:bg-background-200 transition-colors duration-300">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-palette-line text-2xl text-primary-600"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">奇幻精灵世界</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              六大精灵种族，各具独特的色彩魔法与传奇故事。从炽热烈焰到深邃海洋，从璀璨星空到神秘水晶，每一位精灵都在等待与你相遇。
            </p>
          </div>

          <div className="bg-background-100 rounded-lg p-6 md:p-8 text-center group hover:bg-background-200 transition-colors duration-300">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-accent-600"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">色彩冒险篇章</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              每一篇章都是一次全新的色彩探索之旅。跟随精灵们的脚步，穿越神秘的森林、深邃的海洋、璀璨的银河，感受色彩的无尽魅力。
            </p>
          </div>

          <div className="bg-background-100 rounded-lg p-6 md:p-8 text-center group hover:bg-background-200 transition-colors duration-300">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
              <i className="ri-heart-line text-2xl text-secondary-600"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">互动体验故事</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              好色精灵探访记不仅仅是阅读——更是一场身临其境的色彩互动体验。在阅读中感受色彩的温度，在故事中发现世界的美丽。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}